// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 0px;
  padding: 5px;
  display: block;
}

.price {
  font-size: 12px;
  color: var(--ion-color-subtitle);
  font-family: AppFontBlack, sans-serif !important;
}

ion-label {
  font-size: 14px;
  font-family: Tusker, sans-serif !important;
  color: var(--ion-color-primary);
  text-transform: capitalize;
  height: 50px;
  display: flex !important;
  align-items: center;
}

app-tag {
  display: inline-block;
}

ion-item {
  display: flex;
  align-items: center;
  border: 0.5px solid #e5e5e5;
  background: #ffffff;
  --background: #ffffff;
  border-radius: 15px !important;
}

.circle-wrap {
  width: 25px;
  height: 25px;
  position: absolute;
  left: -10px;
  top: 10px;
  transform: translateY(-50%);
  z-index: 99000;
}

.wrapper {
  width: 100%;
  position: relative;
  margin-bottom: 10px;
}

.no-ripple {
  --ripple-color: transparent;
  --background-activated: transparent;
  --background-activated-opacity: transparent;
  --background-focused: transparent;
  --background-focused-opacity: transparent;
  --background-hover: transparent;
  --background-hover-opacity: transparent;
}

.item {
  display: flex;
  align-items: center;
  padding: 10px;
  font-family: AppFont, sans-serif;
  box-sizing: border-box;
  border: 0.5px solid #e5e5e5 !important;
  background: white;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  border-radius: 15px !important;
}
.item .checkbox {
  width: 45px;
  height: -moz-fit-content;
  height: fit-content;
  padding-top: 5px;
}
.item ion-label {
  width: 70%;
  color: #313131 !important;
  color: var(--color-p-span);
  font-size: 14px !important;
  font-family: Tusker, sans-serif !important;
  color: var(--ion-color-primary);
}

.icon_pfand {
  min-width: 45px;
  margin-top: 3px;
}

.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.text_wrap span {
  font-family: Tusker, sans-serif !important;
  color: var(--ion-color-primary);
}

.measurement {
  margin-left: 5px;
}

.content-only {
  display: inline-block;
  position: relative;
  margin-left: 5px;
  width: 20px;
}
.content-only ion-icon {
  position: absolute;
  bottom: -4px;
  left: 0;
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

.price_wrapper_block {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: right;
  padding-top: 7px;
}

.deposit_text {
  font-size: 14px;
  font-family: Tusker, sans-serif;
  color: #878787;
}

.brand_image {
  height: 26px;
  width: 39px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gCAAA;EACA,gDAAA;AACF;;AAEA;EACE,eAAA;EACA,0CAAA;EAEA,+BAAA;EACA,0BAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,qBAAA;EAEA,8BAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAEA;EACE,2BAAA;EACA,mCAAA;EACA,2CAAA;EACA,iCAAA;EACA,yCAAA;EACA,+BAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;EAEA,sBAAA;EACA,sCAAA;EACA,iBAAA;EACA,+CAAA;EACA,8BAAA;AAAF;AAEE;EACE,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,UAAA;EAEA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0CAAA;EAEA,+BAAA;AAFJ;;AAKA;EACE,eAAA;EACA,eAAA;AAFF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AADF;AAGE;EACE,0CAAA;EAEA,+BAAA;AAFJ;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAFF;AAIE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;AAFJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;AAFF;;AAIA;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AADF;;AAIA;EAEE,eAAA;EACA,+BAAA;EACA,cAAA;AAFF;;AAIA;EACE,YAAA;EAGA,WAAA;EACA,mBAAA;AAHF","sourcesContent":["ion-radio-group {\n  width: 100%;\n  border-radius: 0px;\n  padding: 5px;\n  display: block;\n}\n\n.price {\n  font-size: 12px;\n  color: var(--ion-color-subtitle);\n  font-family: AppFontBlack, sans-serif !important;\n}\n\nion-label {\n  font-size: 14px;\n  font-family: Tusker, sans-serif !important;\n\n  color: var(--ion-color-primary);\n  text-transform: capitalize;\n  height: 50px;\n  display: flex !important;\n  align-items: center;\n}\n\napp-tag {\n  display: inline-block;\n}\nion-item {\n  display: flex;\n  align-items: center;\n  border: 0.5px solid #e5e5e5;\n  background: #ffffff;\n  --background: #ffffff;\n\n  border-radius: 15px !important;\n}\n\n.circle-wrap {\n  width: 25px;\n  height: 25px;\n  position: absolute;\n  left: -10px;\n  top: 10px;\n  transform: translateY(-50%);\n  z-index: 99000;\n}\n\n.wrapper {\n  width: 100%;\n  position: relative;\n  margin-bottom: 10px;\n}\n.no-ripple {\n  --ripple-color: transparent;\n  --background-activated: transparent;\n  --background-activated-opacity: transparent;\n  --background-focused: transparent;\n  --background-focused-opacity: transparent;\n  --background-hover: transparent;\n  --background-hover-opacity: transparent;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  font-family: AppFont, sans-serif;\n\n  box-sizing: border-box;\n  border: 0.5px solid #e5e5e5 !important;\n  background: white;\n  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n  border-radius: 15px !important;\n\n  .checkbox {\n    width: 45px;\n    height: fit-content;\n    padding-top: 5px;\n  }\n  ion-label {\n    width: 70%;\n\n    color: #313131 !important;\n    color: var(--color-p-span);\n    font-size: 14px !important;\n    font-family: Tusker, sans-serif !important;\n\n    color: var(--ion-color-primary);\n  }\n}\n.icon_pfand {\n  min-width: 45px;\n  margin-top: 3px;\n}\n.text_wrap {\n  text-align: left;\n  text-wrap: wrap;\n  white-space: normal;\n  word-break: break-word;\n  \n  span {\n    font-family: Tusker, sans-serif !important;\n\n    color: var(--ion-color-primary);\n  }\n}\n.measurement {\n  margin-left: 5px;\n}\n\n.content-only {\n  display: inline-block;\n  position: relative;\n  margin-left: 5px;\n  width: 20px;\n\n  ion-icon {\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    color: var(--ion-color-primary);\n    height: 20px;\n    width: 20px;\n  }\n}\n.price_wrapper_block {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  flex-direction: column;\n}\n.measurment_text {\n  font-family: AppFont, sans-serif;\n  font-size: 10px;\n  color: #9f9f9f;\n  text-align: right;\n  padding-top: 7px;\n\n}\n.deposit_text {\n\n  font-size: 14px;\n  font-family: Tusker, sans-serif;\n  color: #878787;\n}\n.brand_image {\n  height: 26px;\n \n\n  width: 39px;\n  object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
